<div class="multi-select-container" [class.disabled]="disabled">
  <label *ngIf="label" class="multi-select-label">
    {{ label }}
    <span *ngIf="required" class="required-indicator">*</span>
  </label>

  <div class="multi-select" [class.open]="isOpen" [class.error]="showError">
    <div class="selected-items" (click)="toggleDropdown()">
      <div
        class="selected-tags"
        *ngIf="
          !hideSelectedTags && selectedOptions.length > 0;
          else searchOrPlaceholder
        "
      >
        <span class="selected-tag" *ngFor="let option of selectedOptions">
          {{ getOptionLabel(option) }}
          <div class="cros-icon" (click)="removeOption(option.value, $event)">
            <img src="assets/images/cross-icon.svg" class="cross-img" />
          </div>
        </span>
        <input
          *ngIf="isOpen && searchable"
          #searchInput
          type="text"
          class="search-input-inline"
          [placeholder]="searchPlaceholder"
          (input)="onSearch($event)"
          (click)="$event.stopPropagation()"
          [value]="searchTerm"
        />
      </div>

      <ng-template #searchOrPlaceholder>
        <div class="input-area">
          <input
            #searchInput
            type="text"
            class="search-input"
            [placeholder]="placeholder"
            (input)="onSearch($event)"
            (click)="handleInputClick($event)"
            [value]="searchTerm"
            [readonly]="!isOpen || !searchable"
            [class.search-mode]="isOpen && searchable"
            [class.placeholder-mode]="!isOpen || !searchable"
          />
        </div>
      </ng-template>

      <svg
        class="arrow-icon"
        [class.rotated]="isOpen"
        width="12"
        height="12"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6 9l6 6 6-6"
          stroke="#FFFFFFB2"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div
      class="dropdown-options"
      [class.inline]="inlineDropdown"
      *ngIf="isOpen"
    >
      <div
        *ngFor="let option of filteredOptions"
        class="dropdown-option"
        [class.selected]="isSelected(option)"
        (click)="toggleOption(option)"
      >
        <input
          *ngIf="showCheckBox"
          type="checkbox"
          [checked]="isSelected(option)"
          (click)="$event.stopPropagation()"
          style="pointer-events: none"
        />
        <span [innerHTML]="highlightSearchTerm(option.label)"></span>
      </div>

      <div class="no-options" *ngIf="filteredOptions.length === 0">
        {{ noOptionsText }}
      </div>
    </div>
  </div>

  <div class="error-message" *ngIf="showError">
    {{ errorMessage }}
  </div>
</div>
